import { IOAuthProviderConfig } from "../../@types/OAuth";
import { googleHealthService } from "../../services/googleHealthService";
import { OAuthCallbackPage } from "../OAuthCallback";

const GOOGLE_HEALTH_CONFIG: IOAuthProviderConfig = {
  providerName: "Google Health",
  completeAuthorization: googleHealthService.completeAuthorization,
};

export function GoogleHealthCallbackPage() {
  return <OAuthCallbackPage config={GOOGLE_HEALTH_CONFIG} />;
}
